<template>
  <SequenceLabel
    class="ui-signingSequence-labels-SequentialLabel"
    :label="$t('signingSequence.ui.labels.sequential')"
    :for="forId">
    {{ $t('signingSequence.ui.explainers.sequential') }}
  </SequenceLabel>
</template>

<script>
import SequenceLabel from '@/components/ui/signingSequence/labels/SequenceLabel.vue';

export default {
  name: 'SequentialLabel',
  components: { SequenceLabel },
  props: {
    forId: {
      type: String,
      required: false,
    },
  },
};
</script>
